import { productSelectorStyles as styles } from "@insite/content-library/Components/ProductSelector";
import { commonInputIcons } from "@solveindustrial/Utilities/styleguide";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.clearIcon = {
    ...styles.clearIcon,
    css: css`
        ${styles.clearIcon!.css}
        ${commonInputIcons};
        ${mediaQueriesBP.minMD} {
            right: 30px;
            top: 47px;
        }
    `,
    mergeCss: true,
};
